import { ComponentController as BpController, DisplayMode } from '@rta/rta-blueprint-component';
import { useSubscription } from '@rta/rta-blueprint-library';

import { BacksplashIcon } from '@components';
import { Feature, FeatureParams, Require } from '..';

type UseShowBacksplashFeatureParams = Require<FeatureParams, 'controller'>;

export const useShowBacksplashFeature = (params: UseShowBacksplashFeatureParams): Feature<boolean> => {
	const { controller } = params;

	useSubscription(controller, false, [['navigation-display-mode', '*']]);

	const isBlueprintController = controller instanceof BpController;
	const displayMode = isBlueprintController ? controller.navigation.displayMode : null;
	const isBacksplashActive = displayMode === DisplayMode.Backsplash || displayMode === DisplayMode.BacksplashManufacturing;

	// Check if any backsplashes exist across all islands
	const hasBacksplashes = isBlueprintController && controller.kitchen?.design?.islands?.children?.some((island) => {
		const countertop = island.getCountertop?.();
		return countertop?.backsplashes?.children?.length > 0;
	});

	// Enable only when we have a valid controller and backsplashes exist
	const disabled = !isBlueprintController || displayMode === null || !hasBacksplashes;

	return {
		name: 'show-backsplash',
		label: 'backsplash',
		shortcut: '',
		tooltip: 'Show backsplashes',
		icon: (props = {}) => <BacksplashIcon color={disabled ? 'lightgray' : (isBacksplashActive ? 'green' : 'black')} {...props} />,
		disabled,
		value: isBacksplashActive,
		hidden: false,
		handler: () => {
			if (controller instanceof BpController) {
				// Switch to backsplash display mode
				controller.navigation.displayMode = DisplayMode.Backsplash;
			}
		}
	};
};
